import React from 'react';
import PropTypes from 'prop-types';
import { AIconButton } from './';

export default function AImagePreview({ id, img, onClick }) {
	return (
		<figure className="a-image-preview">
			<img src={img} alt="" />
			<figcaption className="a-overlay">
				<AIconButton
					type="close"
					onClick={() => onClick(id)}
					className="no-color a-close-button"
				/>
			</figcaption>
		</figure>
	);
}

AImagePreview.propTypes = {
	id: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	onClick: PropTypes.func,
};

AImagePreview.defaultProps = {
	onClick: undefined,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.image-preview.js